export default __webpack_public_path__ + "static/media/eventx2.af2a2f96.jpg";